import Vue from 'vue';
import Vuex from 'vuex';
import { Listing } from '../../models/Listing';
import { ListingDetail } from '../../models/ListingDetail';
import { RequestViewingViewModel } from '../../models/RequestViewingViewModel';
import RemaxService from '../../services/RemaxService';

Vue.use(Vuex);

export interface ListingState {
    selectedListing: Listing | null;
    selectedListingDetail: ListingDetail | null;
    listingsInMapBounds: Listing[] | null;
}

export default {
    state: {
        selectedListing: null,
        selectedListingDetail: null,
        listingsInMapBounds: null,
    } as ListingState,
    mutations: {
        SET_SELECTED_LISTING(state: ListingState, listing: Listing) {
            state.selectedListing = listing;
        },
        SET_SELECTED_LISTING_DETAIL(state: ListingState, listingDetail: ListingDetail) {
            state.selectedListingDetail = listingDetail;
        },
        SET_LISTINGS_IN_MAP_BOUNDS(state: ListingState, listings: Listing[]) {
            state.listingsInMapBounds = listings;
        },
    },
    actions: {
        // was EVENT_multi_listing_selected_via_map
        multiListingSelectedViaMap(context: any, layer: L.Layer) {
            //
        },

        // was EVENT_single_listing_selected_via_map
        singleListingSelectedViaMap(context: any, layer: L.Layer) {
            //
        },

        // were both events needed?
        // EVENT_selected_listing_changed
        // EVENT_listing_selected
        setSelectedListing(context: any, listing: Listing) {
            context.commit('SET_SELECTED_LISTING', listing);
            if (context.rootState.isLoggedIn || listing.st !== '2') {
                context.dispatch('getListingDetails', listing.sid);
            }

            context.dispatch('clearSelectedCrime');
        },

        // EVENT_features_within_map_bounds_changed
        setListingsInMapBounds(context: any, listings: Listing[]) {
            context.commit('SET_LISTINGS_IN_MAP_BOUNDS', listings);
        },

        getListingDetails(context: any, systemId: string) {
            context.commit('SET_SELECTED_LISTING_DETAIL', null);
            context.dispatch('listingDetailFetchStart', systemId);
            // TODO needs some improved queue logic
            RemaxService.getListingsDetail(systemId, context.rootState.isLoggedIn)
            .then((response) => {
                console.log(response);
                if (response.data && response.data.error) {
                    context.dispatch('listingDetailFetchError');
                    context.dispatch('notify', response.data.error);
                }
                // TODO temp workaround to sync backend timestamps
                if (context.state.selectedListing &&
                    context.state.selectedListing.pi !== null &&
                    context.state.selectedListing.pi.indexOf('?') !== -1 &&
                    context.state.selectedListing.sid === systemId) {
                    const listingTimestamp = context.state.selectedListing.pi.substring(context.state.selectedListing.pi.length - 14, context.state.selectedListing.pi.length);
                    response.data.previewImageURL = response.data.previewImageURL.split('?')[0] + listingTimestamp;
                    for (let i = 0; i < response.data.propertyImages.length; i++) {
                        response.data.propertyImages[i] = response.data.propertyImages[i].split('?')[0] + listingTimestamp;
                    }
                }

                const listingDetail: ListingDetail = new ListingDetail(response.data);
                console.log(listingDetail);
                context.commit('SET_SELECTED_LISTING_DETAIL', listingDetail);
                context.dispatch('listingDetailFetchComplete', listingDetail);
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('listingDetailFetchError');
                context.dispatch('notify', error.message);
            });
        },

        // EVENT_full_list_data_fetch_start
        listingDetailFetchStart(context: any, systemId: string) {
            //
        },
        // EVENT_full_list_data_fetch_complete
        listingDetailFetchComplete(context: any, listingDetail: ListingDetail) {
            //
        },
        // EVENT_full_list_data_fetch_error
        listingDetailFetchError(context: any) {
            //
        },
        // EVENT_show_listing_dialog
        showListingDialog(context: any, listing: Listing) {
            //
        },
        // EVENT_show_listing_dialog_photos
        showListingDialogPhotos(context: any, listing: Listing) {
            //
        },
        // EVENT_show_book_viewing_dialog
        showBookViewingDialog(context: any, listing: Listing) {
            //
        },
        // EVENT_goto_listing
        goToListing(context: any, systemId: number) {
            //
        },
        popupSingleListing(context: any, payload: any) {
            //
        },
        closePopups(context: any) {
            //
        },
        // EVENT_init_request_viewing
        initRequestViewing(context: any, vm: RequestViewingViewModel) {
            RemaxService.requestViewing(vm)
            .then((response) => {
                if (response.data === 'ERROR') {
                    context.dispatch('showRequestError');
                } else {
                    context.dispatch('showRequestSuccess');
                }
            }).catch((error) => {
                context.dispatch('showRequestError');
            });
        },
    },
};
